import { Backdrop, CircularProgress, Stack, Typography } from "@mui/material";
import { Icon } from "@iconify/react";
import { useTranslation } from "react-i18next";

export default function SearchOverlay({ open }) {
    const { t } = useTranslation();
    return (
        <Backdrop
            open={open}
            sx={{
                zIndex: 9999,
                bgcolor: "rgba(26,26,46,0.85)",
                backdropFilter: "blur(6px)",
                flexDirection: "column",
            }}
        >
            <Stack alignItems="center" spacing={3}>
                <Stack
                    alignItems="center"
                    justifyContent="center"
                    sx={{
                        width: 80,
                        height: 80,
                        borderRadius: "50%",
                        bgcolor: "rgba(255,255,255,0.1)",
                        border: "2px solid rgba(255,255,255,0.2)",
                    }}
                >
                    <Icon icon="mdi:bus-clock" width={40} color="white" />
                </Stack>
                <CircularProgress size={44} sx={{ color: "white" }} />
                <Stack alignItems="center" spacing={0.5}>
                    <Typography
                        variant="h6"
                        sx={{
                            color: "white",
                            fontWeight: 700,
                            letterSpacing: "0.5px",
                        }}
                    >
                        {t("results.overlayTitle")}
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            color: "rgba(255,255,255,0.6)",
                            fontWeight: 400,
                        }}
                    >
                        {t("results.overlaySubtitle")}
                    </Typography>
                </Stack>
            </Stack>
        </Backdrop>
    );
}
